import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cee1e062"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "steps" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_path_chapter_holder = _resolveComponent("path-chapter-holder")!
  const _component_ModalPopup = _resolveComponent("ModalPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(this.path.name), 1),
    _createElementVNode("p", null, _toDisplayString(this.path.description), 1),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chapters, (chapter) => {
        return (_openBlock(), _createBlock(_component_path_chapter_holder, {
          key: chapter.name,
          chapter: chapter,
          onShowLogin: _ctx.togglePopup
        }, null, 8, ["chapter", "onShowLogin"]))
      }), 128))
    ]),
    _withDirectives(_createVNode(_component_ModalPopup, { onClose: _ctx.closeModal }, null, 8, ["onClose"]), [
      [_vShow, _ctx.isModalVisible]
    ])
  ]))
}